import parseHTML from '../utils/parseHTML';
const figmaAttributesMap = [{
  attribute: 'data-metadata',
  keyword: 'figmeta'
}, {
  attribute: 'data-buffer',
  keyword: 'figma'
}];

// HTML pasted from Figma contains massive amounts of data inside of
// [data-buffer] and [data-metadata] attributes. This transform removes these
// data attributes, and then removes the span if it's empty.
export const figmaPasteProcessTransform = html => {
  if (!html.includes('<!--(figmeta)') && !html.includes('<!--(figma)')) {
    return html;
  }
  const doc = parseHTML(html);
  figmaAttributesMap.forEach(({
    attribute,
    keyword
  }) => {
    doc.querySelectorAll(`[${attribute}]`).forEach(node => {
      const value = node.getAttribute(attribute) || '';
      if (value.includes(keyword)) {
        node.removeAttribute(attribute);
      }
      if (node.childNodes.length === 0 && node.parentElement) {
        node.parentElement.removeChild(node);
      }
    });
  });
  return doc.innerHTML;
};